import { MenuList } from "./menu-list.js";
import { styles } from "./menu-list.styles.js";
import { template } from "./menu-list.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-menu-list>
 */
export const definition = MenuList.compose({
    name: `${DesignSystem.prefix}-menu-list`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=menu-list.definition.js.map